var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Instance Access")])]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_vm._v(" "+_vm._s(_vm.instance)+" ")])])])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }